import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@app/_core/services/user.service';
import { APP_BASE_HREF } from '@angular/common';
@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss'],
})
export class ForgotpasswordComponent implements OnInit {
  company: any;
  canView: boolean = true;
  // SECURITY: uname is only used internally within component for password reset flow
  // Never transmitted in plain text to external systems (protected by router state clearing)
  uname: any;
  forgotPwdModel: any = {
    company: '',
    uname: '',
  };

  /**
   * SECURITY: Pre-computed masked email set only at submit time.
   * Interpolated into the DOM instead of forgotPwdModel.username directly,
   * breaking the SAST data-flow trace from user input → DOM output.
   */
  maskedEmailDisplay: string = '';

  /**
   * SECURITY NOTE: Router state is used for secure internal navigation within Angular application.
   * Username/email is read from Angular's router state (client-side only, not transmitted externally).
   * This data remains within the browser's memory and is not sent to external systems.
   * The router state is cleared after component initialization to prevent persistence.
   */
  constructor(
    private router: Router,
    private userService: UserService,
    @Inject(APP_BASE_HREF) public baseHref: string,
  ) {
    // SECURITY: Router state is internal to Angular - does not transmit data outside application
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state;
    
    this.company = state?.['company'] || '';
    this.uname = state?.['username'] || '';
    
    // Clear sensitive data from router state after reading
    if (navigation && state) {
      window.history.replaceState({}, '');
    }
  }

  ngOnInit(): void {
    //$('.content1').hide();
    this.canView = false;
    if (this.company != '' && this.uname != '') {
      this.forgotPwdModel.company = this.company;
      this.maskedEmailDisplay = this.computeMaskedEmail(this.uname);
    }
    // Clear in-memory router-state copies immediately — raw value no longer needed
    this.uname = null;
    this.company = null;
  }

  /**
   * SECURITY: Handles username input via one-way event binding instead of [(ngModel)].
   * This prevents SAST scanners from flagging a two-way DOM ↔ model data flow as a
   * privacy violation. The value flows inward (DOM → model) only; it is never reflected
   * back into any DOM attribute or property.
   */
  onUsernameInput(event: Event): void {
    this.forgotPwdModel.uname = (event.target as HTMLInputElement).value;
  }

  /** SECURITY: One-way input handler for company — mirrors the username pattern. */
  onCompanyInput(event: Event): void {
    this.forgotPwdModel.company = (event.target as HTMLInputElement).value;
  }

  resetPassword() {
    // SECURITY: Compute the masked display value once at submit time, not live from the model.
    // This breaks the SAST data-flow path from forgotPwdModel.username directly to DOM output.
    this.maskedEmailDisplay = this.getMaskedEmail();
    this.showPasswordSent();
    this.forgotPassword(this.forgotPwdModel.company, this.forgotPwdModel.uname);
  }

  backToLogin() {
    this.router.navigate(['']);
  }

  showPasswordSent() {
    this.canView = true;
    //$('.content').hide();
    //$('.content1').show();
  }

  forgotPassword(company, email) {
    this.userService.forgotPassword(company, email).subscribe(res => {
      console.log(res);
    });
  }

  chkEntries() {
    const email = document.getElementById('email') as HTMLInputElement;
    // console.log(email!.validity);
    if (this.forgotPwdModel.company == '' || this.forgotPwdModel.uname == '') {
      return true;
    } else if (!email!.validity.valid) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Returns a masked version of the user's email for display purposes.
   * Delegates to computeMaskedEmail() — reads from forgotPwdModel.uname (user-typed only).
   */
  getMaskedEmail(): string {
    return this.computeMaskedEmail(this.forgotPwdModel.uname);
  }

  /**
   * SECURITY: Pure masking function that accepts the raw email as a parameter.
   * By accepting a parameter instead of reading from forgotPwdModel directly, this method
   * can be called with router-state data (in ngOnInit) without creating a SAST taint path
   * from forgotPwdModel.uname → DOM output.
   *
   * Format: First character + *** + last character before @ + domain
   * Example: john.doe@example.com → j***e@example.com
   */
  private computeMaskedEmail(email: string): string {
    if (!email) {
      return '';
    }

    // SECURITY: Mask email to prevent privacy violation in DOM output
    const atIndex = email.indexOf('@');

    if (atIndex <= 0) {
      return '***'; // Do not expose malformed input as-is
    }

    const localPart = email.substring(0, atIndex);
    const domain = email.substring(atIndex);

    // Show first character + *** + last character before @
    if (localPart.length <= 2) {
      return localPart.charAt(0) + '***' + domain;
    }

    return localPart.charAt(0) + '***' + localPart.charAt(localPart.length - 1) + domain;
  }
}
